import React from 'react'
import ContactsAndRegistration from '../programs/intramural/ContactsAndRegistration'

const RegisterIntramural = () => {
  return (
    <div id='register-pre-travel' sx={{pt: '65px'}}>
        <ContactsAndRegistration/>
    </div>
  )
}

export default RegisterIntramural